import styled from 'styled-components';
import Fade from 'react-reveal'

function PodcastCard() {
  return (
    <>
    <Fade>

    <Contaienr>
      <div className="podcast-container">
        <a href="https://www.youtube.com/watch?v=pvXmovpzTj4" target="_blank">
          <img src="https://images.unsplash.com/photo-1589903308904-1010c2294adc?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80" alt="" />
        </a>
      {/* <h1 className='h1'>Podcast</h1> */}
      </div>
    </Contaienr>
    </Fade>
    </>
  )
}

export default PodcastCard
const Contaienr = styled.div` 
img{
    width:100% ;
    transition:.5s ;
    &:hover{
      transform:scale(.9) ;
    }
}
.podcast-container h1{
  color:black;
}
h1{
  font-family:Arial, Helvetica, sans-serif ;
  font-size:20px ;
}
`